import React from 'react';
import Icon from 'carbon-react/lib/components/icon';
import { useIntl } from 'react-intl';

import * as styles from './insights-modal.scss';

type HealthStatus = 'green' | 'yellow' | 'red';

const SCORE_COLORS: Record<HealthStatus, string> = {
  green: '#00811F',
  yellow: '#D64309',
  red: '#DB004E'
};

interface HealthScoreSummaryProps {
  score: number;
  status: HealthStatus;
  onHowCalculated: () => void;
}

export const HealthScoreSummary = ({ score, status, onHowCalculated }: HealthScoreSummaryProps) => {
  const intl = useIntl();

  return (
    <section className={styles.healthScoreSummary}>
      <div className={styles.healthScoreDetails}>
        <span className={styles.healthScoreLabel}>
          {intl.formatMessage({ id: 'aiInsights.healthCard.healthScore', defaultMessage: 'Health score:' })}
        </span>
        <span className={styles.healthScoreValue} style={{ color: SCORE_COLORS[status] }}>
          {`${score}%`}
        </span>
      </div>

      <button type="button" className={styles.calculationTrigger} onClick={onHowCalculated}>
        <span>
          {intl.formatMessage({
            id: 'aiInsights.healthCard.howIsThisCalculated',
            defaultMessage: 'How is this calculated'
          })}
        </span>
        <Icon
          type="question"
          color="rgba(0, 0, 0, 0.92)"
          className={styles.calculationIcon}
          aria-hidden
          focusable={false}
        />
      </button>
    </section>
  );
};
